<template>
    <div class="el-finger">
        <slot></slot>
    </div>
</template>

<script>
    import { randInt, timeout } from 'donot';

    export default {
        methods : {
            async animateFingers() {
                const rot = randInt(360);
                this.$el.style = `transform:rotate(${rot}deg)`;
                await timeout(1000);
                this.animateFingers();
            }
        },

        mounted() {
            this.animateFingers();
        }
    }
</script>